<div class="chart-app-container" [class.embed-view]="isEmbeddedView" [class.fullscreen-view]="isFullscreenView"
  [class.toolbar-dropdown-open]="!!activeDropdown || showScreenshotDropdown || showWatchlistSelector || showWatchlistMenu">
  <div class="mobile-dropdown-backdrop" *ngIf="isAnyDropdownOpen()" (click)="closeMenusAfterAction()"></div>
  <!-- Sleek TradingView-style Toolbar -->
  <div class="trading-toolbar" [class.fullscreen-toolbar-split]="isFullscreenView">
    <!-- Normal / embed: brand + ticker search -->
    <ng-container *ngIf="showToolbar && !isFullscreenView">
      <div class="toolbar-top-brand" *ngIf="showBrandLogo" aria-label="InsiderMaxx">
        <img src="/InsiderMaxx-RGB.svg" alt="InsiderMaxx" class="toolbar-top-brand-logo" />
      </div>
      <ng-container *ngTemplateOutlet="tickerSearchGroupTpl"></ng-container>
    </ng-container>

    <!-- Fullscreen: single top row — brand + search (tools sit in toolbar-right on same row) -->
    <div class="fullscreen-primary-header" *ngIf="isFullscreenView && showToolbar">
      <div class="toolbar-top-brand" *ngIf="showBrandLogo" aria-label="InsiderMaxx">
        <img src="/InsiderMaxx-RGB.svg" alt="InsiderMaxx" class="toolbar-top-brand-logo" />
      </div>
      <ng-container *ngTemplateOutlet="tickerSearchGroupTpl"></ng-container>
    </div>

    <ng-template #tickerSearchGroupTpl>
    <div class="ticker-search-group" [class.editing]="isEditingSymbol"
      [class.fullscreen-direct-input]="isFullscreenView">
      <div class="ticker-input-group">
        <div class="search-input-wrapper" [class.has-value]="!!editingSymbol?.trim()">
          <span class="search-input-icon-wrap" aria-hidden="true">
            <i data-lucide="search" class="search-input-icon"></i>
          </span>

          <input #symbolInput type="text" [(ngModel)]="editingSymbol" (input)="onSearchInput($event)"
            (focus)="startEditingSymbol()"
            (keydown.enter)="confirmSymbolEdit(); $event.preventDefault()"
            (keyup.enter)="confirmSymbolEdit()" (keyup.escape)="cancelSymbolEdit()" class="ticker-input-enhanced"
            placeholder="Search ticker" autocomplete="off" spellcheck="false">
          <button type="button" class="search-clear-btn" *ngIf="editingSymbol?.trim()"
            (mousedown)="$event.preventDefault()" (click)="clearHeaderSearchInput($event)" aria-label="Clear search">
            <svg class="search-clear-icon" viewBox="0 0 24 24" aria-hidden="true">
              <path d="M6 6l12 12M18 6L6 18"></path>
            </svg>
          </button>

          <div class="search-results-dropdown" *ngIf="showSearchResults || isSearching">
            <div class="search-loading" *ngIf="isSearching">
              <i data-lucide="loader-2" class="loading-spinner"></i>
              <span>Searching...</span>
            </div>

            <div class="search-result-item" *ngFor="let result of searchResults"
              (mousedown)="selectSearchResult(result); $event.preventDefault(); $event.stopPropagation()"
              (click)="selectSearchResult(result); $event.preventDefault(); $event.stopPropagation()"
              [title]="result.name || result.symbol">
              <div class="result-main">
                <div class="result-symbol">{{ result.symbol }}</div>
                <div class="result-name">{{ result.name || result.symbol }}</div>
              </div>
              <div class="result-side">
                <div class="result-type">{{ result.assetType || 'equity' }}</div>
                <div class="result-exchange">{{ result.exchange || 'NMS' }}</div>
              </div>
              <div class="result-quote" *ngIf="result.lastPrice !== undefined || result.change !== undefined">
                <span class="result-ltp">{{ result.lastPrice !== undefined ? ('$' + (result.lastPrice | number:'1.2-2'))
                  : '--' }}</span>
                <span class="result-change" [class.positive]="(result.change || 0) >= 0"
                  [class.negative]="(result.change || 0) < 0">
                  {{ result.change !== undefined ? ((result.change >= 0 ? '+' : '') + (result.change | number:'1.2-2'))
                  : '--' }}
                  <span *ngIf="result.changePercent !== undefined">
                    ({{ result.changePercent >= 0 ? '+' : '' }}{{ result.changePercent | number:'1.2-2' }}%)
                  </span>
                </span>
              </div>
            </div>

            <div class="search-no-results"
              *ngIf="!isSearching && searchResults.length === 0 && searchQuery.length >= 2">
              <span>No results found for "{{searchQuery}}"</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    </ng-template>

    <!-- Right Side Toolbar Group -->
    <div class="toolbar-right" [class.toolbar-right--fullscreen-split]="isFullscreenView">
      <div class="toolbar-right-tools">
      <!-- Chart Type -->
      <div class="tool-dropdown" [class.active]="activeDropdown === 'series'">
        <button class="tool-btn" (click)="toggleDropdown('series')" title="Chart style" data-tooltip="Chart style">
          <i [attr.data-lucide]="getCurrentChartTypeIcon()" class="tool-icon"></i>
        </button>
        <div class="tool-menu chart-type-menu" *ngIf="activeDropdown === 'series'">
          <div class="tool-menu-header">Chart Style</div>

          <div class="tool-menu-section">
            <div class="menu-list-container">
              <div class="tool-item" *ngFor="let type of seriesTypes; trackBy: trackByChartTypeId"
                [class.active]="isActiveChartType(type)">
                <i [attr.data-lucide]="getChartTypeItemIcon(type)" class="tool-item-icon"></i>
                <span class="tool-item-label" (click)="changeSeriesType(type.value)">{{type.label}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Indicators -->
      <div class="tool-dropdown" [class.active]="activeDropdown === 'indicators'">
        <button class="tool-btn" (click)="toggleDropdown('indicators')" title="Technical indicators"
          data-tooltip="Technical indicators" [class.has-active]="hasActiveIndicators()">
          <i data-lucide="bar-chart-3" class="tool-icon"></i>
          <span class="indicator-count" *ngIf="getActiveIndicatorTypeCount() > 0">
            {{ getActiveIndicatorTypeCount() }}
          </span>
        </button>
        <div class="tool-menu" *ngIf="activeDropdown === 'indicators'">
          <div class="tool-menu-header">Technical Indicators</div>
          <!-- <div class="tool-item indicator-tool-item" (click)="toggleVolume()"
            [class.active]="showVolume"
            [title]="showVolume ? 'Hide volume bars' : 'Show volume bars'">
            <i data-lucide="bar-chart-3" class="tool-item-icon indicator-dropdown-icon" aria-hidden="true"></i>
            <span class="tool-item-label">
              Volume
              <span class="tool-item-subtext">{{ showVolume ? 'On' : 'Off' }}</span>
            </span>
          </div> -->
          <div class="tool-item indicator-tool-item" *ngFor="let indicatorType of availableIndicatorTypes"
            [class.active]="isIndicatorTypeActive(indicatorType.type)" (click)="toggleIndicatorType(indicatorType.type)"
            [title]="isIndicatorTypeActive(indicatorType.type) ? 'Click to remove from chart' : 'Click to add to chart'">
            <i [attr.data-lucide]="getIndicatorIcon(indicatorType.type)" class="tool-item-icon indicator-dropdown-icon"
              aria-hidden="true"></i>
            <span class="tool-item-label">{{indicatorType.displayName}}</span>
          </div>

        </div>
      </div>

      <!-- Drawing Tools (dropdown) -->
      <div class="tool-dropdown" [class.active]="activeDropdown === 'drawing'">
        <button class="tool-btn" (click)="toggleDropdown('drawing')" title="Drawing tools" data-tooltip="Drawing tools"
          [class.has-active]="isDrawingMode || isPenMode || isTextMode || isArrowMode || horizontalLines.length > 0 || textAnnotations.length > 0 || penDrawings.length > 0 || arrowDrawings.length > 0"
          [class.paused]="isDrawingMode && showLineToolbar">
          <i data-lucide="edit-3" class="tool-icon"></i>
        </button>
        <div class="tool-menu" *ngIf="activeDropdown === 'drawing'">
          <div class="tool-menu-header">Drawing Tools</div>
          <div class="tool-item drawing-tool-item" [class.active]="isDrawingMode" (click)="toggleDrawingMode()"
            title="Line Tool – draw horizontal lines (click to activate, click again to exit)">
            <i data-lucide="minus" class="tool-item-icon drawing-dropdown-icon" aria-hidden="true"></i>
            <span class="tool-item-label">Line Tool</span>
          </div>
          <div class="tool-menu-status" *ngIf="isDrawingMode && showLineToolbar">
            <span class="status-text"><i data-lucide="pause"></i> Drawing paused while editing line</span>
          </div>

          <div class="tool-item drawing-tool-item" [class.active]="isPenMode" (click)="togglePenMode()"
            title="Pen Tool – freehand drawing (click to activate, click again to exit)">
            <i data-lucide="pencil" class="tool-item-icon drawing-dropdown-icon" aria-hidden="true"></i>
            <span class="tool-item-label">Pen Tool</span>
          </div>

          <!-- Pen Options -->
          <div *ngIf="isPenMode" class="pen-options-container">
            <div class="pen-option-section">
              <div class="pen-option-header">Pen Size</div>
              <div class="pen-size-grid">
                <div class="pen-size-option" [class.selected]="penSize === 1" (click)="setPenSize(1)"
                  title="Thin (1px)">
                  <div class="pen-preview size-1"></div>
                </div>
                <div class="pen-size-option" [class.selected]="penSize === 2" (click)="setPenSize(2)"
                  title="Medium (2px)">
                  <div class="pen-preview size-2"></div>
                </div>
                <div class="pen-size-option" [class.selected]="penSize === 3" (click)="setPenSize(3)"
                  title="Thick (3px)">
                  <div class="pen-preview size-3"></div>
                </div>
                <div class="pen-size-option" [class.selected]="penSize === 4" (click)="setPenSize(4)"
                  title="Extra Thick (4px)">
                  <div class="pen-preview size-4"></div>
                </div>
              </div>
            </div>
            <div class="pen-option-section">
              <div class="pen-option-header">Pen Color</div>
              <div class="pen-color-grid">
                <div *ngFor="let color of availableColors" class="pen-color-option"
                  [class.selected]="penColor === color" [style.background-color]="color" (click)="setPenColor(color)"
                  [title]="color">
                </div>
              </div>
            </div>
          </div>

          <div class="tool-item drawing-tool-item" [class.active]="isTextMode" (click)="toggleTextMode()"
            title="Text Tool – add text annotations (click to activate, click again to exit)">
            <i data-lucide="align-left" class="tool-item-icon drawing-dropdown-icon" aria-hidden="true"></i>
            <span class="tool-item-label">Text Tool</span>
          </div>

          <div class="tool-menu-status" *ngIf="isTextMode && showLineToolbar">
            <span class="status-text"><i data-lucide="pause"></i> Text mode paused while editing</span>
          </div>

          <div class="tool-item drawing-tool-item" [class.active]="isArrowMode" (click)="toggleArrowMode()"
            title="Arrow Tool – click the chart to set the arrow tail, then click again to drop the arrow head">
            <i data-lucide="arrow-up-right" class="tool-item-icon drawing-dropdown-icon" aria-hidden="true"></i>
            <span class="tool-item-label">Arrow Tool</span>
          </div>

          <div class="tool-item" *ngIf="horizontalLines.length > 0" (click)="clearAllLines()"
            title="Remove all horizontal lines from the chart">
            <span class="tool-item-label">Clear Lines ({{horizontalLines.length}})</span>
          </div>
          <div class="tool-item" *ngIf="penDrawings.length > 0" (click)="clearAllPenDrawings()"
            title="Remove all pen drawings from the chart">
            <span class="tool-item-label">Clear Drawings ({{penDrawings.length}})</span>
          </div>
          <div class="tool-item" *ngIf="textAnnotations.length > 0" (click)="clearAllTextAnnotations()"
            title="Remove all text annotations from the chart">
            <span class="tool-item-label">Clear Text ({{textAnnotations.length}})</span>
          </div>
          <div class="tool-item" *ngIf="arrowDrawings.length > 0" (click)="clearAllArrowDrawings()"
            title="Remove all arrows from the chart">
            <span class="tool-item-label">Clear Arrows ({{arrowDrawings.length}})</span>
          </div>
          <div class="tool-item" *ngIf="systemLines.length > 0" (click)="clearAllSystemLines()"
            title="Remove all system lines from the chart">
            <span class="tool-item-label">Clear System Lines ({{systemLines.length}})</span>
          </div>
        </div>
      </div>


      <!-- Events -->
      <!-- <div class="tool-dropdown" *ngIf="!isEmbeddedView" [class.active]="activeDropdown === 'events'">
        <button class="tool-btn" (click)="toggleDropdown('events')" title="Corporate events"
          data-tooltip="Corporate events">
          <i data-lucide="calendar" class="tool-icon"></i>
        </button>
        <div class="tool-menu" *ngIf="activeDropdown === 'events'">
          <div class="tool-item" (click)="toggleEventType('earnings')">
            <input type="checkbox" [checked]="eventStates.earnings" readonly>
            <span class="tool-item-label"><i data-lucide="trending-up"></i> Earnings</span>
          </div>
          <div class="tool-item" (click)="toggleEventType('dividend')">
            <input type="checkbox" [checked]="eventStates.dividend" readonly>
            <span class="tool-item-label"><i data-lucide="dollar-sign"></i> Dividends</span>
          </div>
          <div class="tool-item" (click)="toggleEventType('split')">
            <input type="checkbox" [checked]="eventStates.split" readonly>
            <span class="tool-item-label"><i data-lucide="split"></i> Splits</span>
          </div>
        </div>

      </div> -->

      <!-- Right Side Actions (Outside toolbar-right) -->
      <!-- Add to Watchlist Button -->
      <div class="tool-dropdown" *ngIf="currentSymbol">
        <button class="tool-btn watchlist-btn" (click)="toggleWatchlistSelector()"
          [class.active]="showWatchlistSelector"
          [title]="isCurrentSymbolInWatchlist() ? 'Manage watchlists' : 'Add to watchlist'"
          [attr.data-tooltip]="isCurrentSymbolInWatchlist() ? 'Manage watchlists' : 'Add to watchlist'">
          <i [attr.data-lucide]="isCurrentSymbolInWatchlist() ? 'star' : 'star'" class="tool-icon"
            [class.filled]="isCurrentSymbolInWatchlist()"></i>
        </button>

        <!-- Quick Watchlist Selector Dropdown -->
        <div class="watchlist-selector-backdrop" *ngIf="showWatchlistSelector" (click)="showWatchlistSelector = false"></div>
        <div class="watchlist-selector-dropdown" *ngIf="showWatchlistSelector">
          <div class="dropdown-header">
            <span class="dropdown-title">Add "{{currentSymbol}}" to:</span>
            <button class="close-btn" (click)="showWatchlistSelector = false">×</button>
          </div>

          <!-- <div class="watchlist-options">
          <div *ngFor="let watchlist of watchlists" 
               class="watchlist-option"
               [class.has-symbol]="watchlistContainsSymbol(watchlist, currentSymbol)"
               (click)="toggleSymbolInWatchlist(watchlist, currentSymbol)">
            <span class="watchlist-name">{{ watchlist.name }}</span>
            <span class="watchlist-status">
              <i *ngIf="watchlistContainsSymbol(watchlist, currentSymbol)" 
                 data-lucide="check" 
                 class="watchlist-icon check-icon"></i>
              <i *ngIf="!watchlistContainsSymbol(watchlist, currentSymbol)" 
                 data-lucide="plus" 
                 class="watchlist-icon plus-icon"></i>
            </span>
          </div>
        </div> -->

          <!-- API Watchlists -->
          <div class="watchlist-options" *ngIf="apiWatchlists.length > 0">
            <!-- <div class="watchlist-section-header">API Watchlists</div> -->
            <div *ngFor="let watchlist of apiWatchlists" class="watchlist-option"
              [class.has-symbol]="isSymbolInSpecificApiWatchlist(watchlist, currentSymbol)"
              (click)="toggleSymbolInApiWatchlist(watchlist, currentSymbol)">
              <span class="watchlist-name">{{ watchlist.name || watchlist.title || 'Watchlist' }}</span>
              <span class="watchlist-status">
                <i *ngIf="isSymbolInSpecificApiWatchlist(watchlist, currentSymbol)" data-lucide="minus"
                  class="watchlist-icon minus-icon"></i>
                <i *ngIf="!isSymbolInSpecificApiWatchlist(watchlist, currentSymbol)" data-lucide="plus"
                  class="watchlist-icon plus-icon"></i>
              </span>
            </div>
          </div>

          <div class="dropdown-footer">
            <button class="create-watchlist-btn" (click)="showCreateWatchlist = true">
              + New Watchlist
            </button>
          </div>
        </div>
      </div>

      <!-- Refresh Chart -->
      <div class="tool-dropdown" *ngIf="currentSymbol && !isEmbeddedView">
        <button class="tool-btn" (click)="refreshChart()" title="Refresh chart" data-tooltip="Refresh chart"
          [disabled]="isLoading">
          <i data-lucide="refresh-cw" class="tool-icon"></i>
        </button>
      </div>

      <!-- Maximize (open fullscreen in new tab) -->
      <div class="tool-dropdown" *ngIf="showPopupButton && !isFullscreenView">
        <button class="tool-btn" (click)="openPopupWindow()" title="Open fullscreen chart"
          data-tooltip="Open fullscreen chart" aria-label="Open fullscreen chart">
          <i data-lucide="maximize-2" class="tool-icon"></i>
        </button>
      </div>

      <!-- Recent Tickers Toggle -->
      <div class="tool-dropdown" *ngIf="!isEmbeddedView && !isFullscreenView">
        <button class="tool-btn" (click)="toggleRecentTickersPane()" title="Recent tickers & watchlists"
          data-tooltip="Recent tickers & watchlists">
          <i data-lucide="clock" class="tool-icon"></i>
        </button>
      </div>

      <!-- Screenshot -->
      <div class="tool-dropdown" [class.active]="showScreenshotDropdown">
        <button class="tool-btn" (click)="toggleDropdown('screenshot')" title="Screenshot & export"
          data-tooltip="Screenshot & export">
          <i data-lucide="camera" class="tool-icon"></i>
        </button>
        <div class="tool-menu" *ngIf="showScreenshotDropdown">
          <div class="tool-menu-header">Screenshot</div>
          <div class="tool-item" (click)="downloadChartImage()">
            <i data-lucide="download" class="tool-icon"></i>
            <span class="tool-item-label">Download Image</span>
          </div>
          <div class="tool-item" (click)="copyChartImage()">
            <i data-lucide="copy" class="tool-icon"></i>
            <span class="tool-item-label">Copy Image</span>
          </div>
        </div>
      </div>
      </div>
    </div>

    <div class="toolbar-top-accent-line" *ngIf="isFullscreenView && showToolbar" aria-hidden="true"></div>

    <!-- Fullscreen: stock quote row below header -->
    <div class="fullscreen-market-summary" *ngIf="isFullscreenView && showToolbar">
      <div class="fs-col fs-col--identity">
        <div class="fs-title">
          {{ tickerDetails?.companyName || currentSymbol }}
          <span class="fs-symbol">({{ currentSymbol }})</span>
        </div>
        <div class="fs-subline">
          {{ tickerDetails?.exchangeDisplay || 'NasdaqGS' }} - Nasdaq Real Time Price <span class="fs-bullet">•</span> {{ tickerDetails?.currency || 'USD' }}
        </div>
      </div>

      <div class="fs-col fs-col--regular">
        <div class="fs-quote-inline">
          <span class="fs-price-inline">{{ tickerDetails?.close != null ? (tickerDetails?.close | currency:'USD':'symbol':'1.2-2') : '--' }}</span>
          <span class="fs-delta"
            [class.positive]="(tickerDetails?.change || 0) >= 0"
            [class.negative]="(tickerDetails?.change || 0) < 0">
            {{ tickerDetails?.change != null ? (((tickerDetails?.change || 0) >= 0 ? '+' : '') + (tickerDetails?.change | number:'1.2-2')) : '--' }}
          </span>
          <span class="fs-pct"
            [class.positive]="(tickerDetails?.changePercent || 0) >= 0"
            [class.negative]="(tickerDetails?.changePercent || 0) < 0">
            {{ tickerDetails?.changePercent != null ? ('(' + ((tickerDetails?.changePercent || 0) >= 0 ? '+' : '') + (tickerDetails?.changePercent | number:'1.2-2') + '%)') : '--' }}
          </span>
        </div>
        <div class="fs-subline">
          At close: {{ getAtCloseDisplay() }}
        </div>
      </div>
    </div>

  </div>
  <!-- Chart Wrapper -->
  <div class="chart-wrapper" [class.sidebar-open]="isRecentTickersPaneOpen"
    [class.interval-dropdown-open]="showIntervalDropdown">
    <!-- Main Content Area -->
    <div class="main-content">
      <!-- Chart Container Wrapper -->
      <div class="chart-container-wrapper" [class.embed-view]="isEmbeddedView">
        <div class="chart-container" [class.with-recent-pane]="isRecentTickersPaneOpen">
          <div #chartContainer class="chart-canvas"   [class.drawing-mode]="isDrawingMode" [class.pen-mode]="isPenMode"
            [class.text-mode]="isTextMode" [class.loading]="isLoading"></div>

          <div class="chart-watermark-branding" aria-hidden="true">
            <img src="/InsiderMaxx-RGB.svg" alt="InsiderMax by Trader's Edge" class="watermark-logo" />
            <span class="watermark-byline">By Trader's Edge</span>
          </div>

          <!-- Active Indicators quick controls (Top Left of Chart) -->
          <div class="active-indicators-panel" *ngIf="indicators.length > 0"
            [class.collapsed]="indicatorsPanelCollapsed">
            <div class="active-indicators-header">
              <button type="button" class="active-indicators-toggle"
                (click)="toggleIndicatorsPanelCollapsed(); $event.stopPropagation()"
                [attr.aria-expanded]="!indicatorsPanelCollapsed"
                [attr.aria-label]="indicatorsPanelCollapsed ? 'Expand active indicators panel' : 'Collapse active indicators panel'"
                title="Toggle indicators panel">
                <span class="active-indicators-title">Indicators</span>
                <span class="active-indicators-count">{{ indicators.length }}</span>
                <span class="collapse-arrow" aria-hidden="true">{{ indicatorsPanelCollapsed ? '▶' : '▼' }}</span>
              </button>
            </div>
            <div class="active-indicators-list">
              <div class="active-indicator-chip"
                *ngFor="let indicator of getActiveIndicatorsForPanel(); trackBy: trackByIndicatorId"
                [class.chip-hidden]="!indicator.visible">
                <div class="chip-color-dot" [style.background-color]="indicator.color"></div>
                <div class="chip-info">
                  <div class="chip-name">{{ indicator.name }}</div>
                </div>
                <div class="chip-actions">
                  <div class="chip-value-slot">
                    <span class="chip-live-value" *ngIf="getIndicatorChipLiveValue(indicator) !== null">
                      {{ getIndicatorChipLiveValue(indicator) | number:'1.2-2' }}
                    </span>
                    <span class="chip-value" *ngIf="getIndicatorChipLiveValue(indicator) === null">
                      {{ getIndicatorChipValue(indicator) }}
                    </span>
                  </div>
                  <!-- Settings -->
                  <button class="chip-btn chip-settings" (click)="selectIndicator(indicator); $event.stopPropagation()"
                    title="Indicator settings">
                    <i data-lucide="settings-2" class="chip-icon"></i>
                  </button>
                  <!-- Show/hide -->
                  <button class="chip-btn chip-toggle"
                    (click)="toggleIndicatorVisibility(indicator.id); $event.stopPropagation()"
                    [title]="indicator.visible ? 'Hide from chart' : 'Show on chart'">
                    <i [attr.data-lucide]="indicator.visible ? 'eye' : 'eye-off'" class="chip-icon"></i>
                  </button>
                  <!-- Remove -->
                  <button class="chip-btn chip-remove" (click)="removeIndicator(indicator.id); $event.stopPropagation()"
                    title="Remove indicator">
                    <i data-lucide="x" class="chip-icon"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- Indicator Settings Popup - Moving Average & others -->
          <div class="indicator-settings-overlay" *ngIf="showIndicatorSettings && selectedIndicator"
            (click)="closeIndicatorSettings()">
            <div class="indicator-settings-popup tv-settings-popup" (click)="$event.stopPropagation()">
              <div class="tv-settings-header">
                <span class="tv-settings-title">{{getIndicatorDisplayTitle(selectedIndicator.type)}}</span>
                <button class="tv-close-btn" (click)="closeIndicatorSettings()" type="button" aria-label="Close">
                  <i data-lucide="x"></i>
                </button>
              </div>

              <div class="tv-settings-body">

                <ng-container *ngIf="selectedIndicator.type === 'moving_average'">
                  <div class="tv-row">
                    <label class="tv-label" for="ma-length">Length</label>
                    <input type="number" id="ma-length" class="tv-input" min="1" max="500"
                      [value]="selectedIndicator.settings['period']"
                      (change)="updateIndicatorSetting('period', $any($event.target).value)" placeholder="e.g. 50">
                  </div>
                  <div class="tv-row">
                    <label class="tv-label" for="ma-type">Type</label>
                    <select id="ma-type" class="tv-select"
                      [ngModel]="selectedIndicator.settings['movingAverageType'] || 'exponential'"
                      (ngModelChange)="updateIndicatorSetting('movingAverageType', $event)">
                      <option value="exponential">Exponential</option>
                      <option value="simple">Simple</option>
                    </select>
                  </div>
                  <div class="tv-row">
                    <label class="tv-label" for="ma-line-width">Line width</label>
                    <select id="ma-line-width" class="tv-select"
                      [ngModel]="selectedIndicator.settings['lineWidth'] ?? 1"
                      (ngModelChange)="updateIndicatorSetting('lineWidth', $event)">
                      <option [ngValue]="1">1 — thin</option>
                      <option [ngValue]="2">2</option>
                      <option [ngValue]="3">3</option>
                      <option [ngValue]="4">4 — bold</option>
                    </select>
                  </div>
                  <div class="tv-divider"></div>
                  <div class="tv-row">
                    <label class="tv-label" for="ma-color">Color</label>
                    <div class="tv-color-row">
                      <input type="color" id="ma-color" class="tv-color-swatch" [value]="selectedIndicator.color"
                        (input)="setIndicatorColor($any($event.target).value)">
                      <span class="tv-color-hex">{{ selectedIndicator.color }}</span>
                    </div>
                  </div>
                </ng-container>

                <!-- ── RSI ─────────────────────────────────────────── -->
                <ng-container *ngIf="selectedIndicator.type === 'rsi'">
                  <div class="tv-row">
                    <span class="tv-label">Period</span>
                    <input type="number" class="tv-input" min="1" max="100"
                      [value]="selectedIndicator.settings['period']"
                      (change)="updateIndicatorSetting('period', $any($event.target).value)">
                  </div>
                  <div class="tv-row">
                    <span class="tv-label">Field</span>
                    <select class="tv-select" [value]="selectedIndicator.settings['source'] || 'close'"
                      (change)="updateIndicatorSetting('source', $any($event.target).value)">
                      <option value="close">Close</option>
                      <option value="open">Open</option>
                      <option value="high">High</option>
                      <option value="low">Low</option>
                    </select>
                  </div>
                  <div class="tv-row">
                    <span class="tv-label">Overbought</span>
                    <input type="number" class="tv-input" min="50" max="100"
                      [value]="selectedIndicator.settings['overboughtLevel'] || 70"
                      (change)="updateIndicatorSetting('overboughtLevel', $any($event.target).value)">
                  </div>
                  <div class="tv-row">
                    <span class="tv-label">Oversold</span>
                    <input type="number" class="tv-input" min="0" max="50"
                      [value]="selectedIndicator.settings['oversoldLevel'] || 30"
                      (change)="updateIndicatorSetting('oversoldLevel', $any($event.target).value)">
                  </div>
                  <div class="tv-row">
                    <span class="tv-label">Line width</span>
                    <select class="tv-select"
                      [ngModel]="selectedIndicator.settings['lineWidth'] ?? 1"
                      (ngModelChange)="updateIndicatorSetting('lineWidth', $event)">
                      <option [ngValue]="1">1 — thin</option>
                      <option [ngValue]="2">2</option>
                      <option [ngValue]="3">3</option>
                      <option [ngValue]="4">4 — bold</option>
                    </select>
                  </div>
                  <div class="tv-divider"></div>
                  <div class="tv-row">
                    <span class="tv-label">Color</span>
                    <input type="color" class="tv-color-swatch" [value]="selectedIndicator.color"
                      (input)="setIndicatorColor($any($event.target).value)">
                  </div>
                </ng-container>

                <!-- ── MACD ────────────────────────────────────────── -->
                <ng-container *ngIf="selectedIndicator.type === 'macd'">
                  <div class="tv-row">
                    <span class="tv-label">Fast Period</span>
                    <input type="number" class="tv-input" min="1" max="100"
                      [value]="selectedIndicator.settings['fastPeriod'] || 12"
                      (change)="updateIndicatorSetting('fastPeriod', $any($event.target).value)">
                  </div>
                  <div class="tv-row">
                    <span class="tv-label">Slow Period</span>
                    <input type="number" class="tv-input" min="1" max="200"
                      [value]="selectedIndicator.settings['slowPeriod'] || 26"
                      (change)="updateIndicatorSetting('slowPeriod', $any($event.target).value)">
                  </div>
                  <div class="tv-row">
                    <span class="tv-label">Signal Period</span>
                    <input type="number" class="tv-input" min="1" max="50"
                      [value]="selectedIndicator.settings['signalPeriod'] || 9"
                      (change)="updateIndicatorSetting('signalPeriod', $any($event.target).value)">
                  </div>
                  <div class="tv-row">
                    <span class="tv-label">Field</span>
                    <select class="tv-select" [value]="selectedIndicator.settings['source'] || 'close'"
                      (change)="updateIndicatorSetting('source', $any($event.target).value)">
                      <option value="close">Close</option>
                      <option value="open">Open</option>
                      <option value="high">High</option>
                      <option value="low">Low</option>
                    </select>
                  </div>
                  <div class="tv-row">
                    <span class="tv-label">Line width</span>
                    <select class="tv-select"
                      [ngModel]="selectedIndicator.settings['lineWidth'] ?? 1"
                      (ngModelChange)="updateIndicatorSetting('lineWidth', $event)">
                      <option [ngValue]="1">1 — thin (MACD line)</option>
                      <option [ngValue]="2">2</option>
                      <option [ngValue]="3">3</option>
                      <option [ngValue]="4">4 — bold</option>
                    </select>
                  </div>
                  <div class="tv-divider"></div>
                  <div class="tv-row">
                    <span class="tv-label">Color</span>
                    <input type="color" class="tv-color-swatch" [value]="selectedIndicator.color"
                      (input)="setIndicatorColor($any($event.target).value)">
                  </div>
                </ng-container>

                <!-- ── Bollinger Bands ─────────────────────────────── -->
                <ng-container *ngIf="selectedIndicator.type === 'bollinger_bands'">
                  <div class="tv-row">
                    <span class="tv-label">Period</span>
                    <input type="number" class="tv-input" min="1" max="200"
                      [value]="selectedIndicator.settings['period']"
                      (change)="updateIndicatorSetting('period', $any($event.target).value)">
                  </div>
                  <div class="tv-row">
                    <span class="tv-label">Std Dev</span>
                    <input type="number" class="tv-input" min="0.5" max="10" step="0.5"
                      [value]="selectedIndicator.settings['standardDeviations'] || 2"
                      (change)="updateIndicatorSetting('standardDeviations', $any($event.target).value)">
                  </div>
                  <div class="tv-row">
                    <span class="tv-label">Field</span>
                    <select class="tv-select" [value]="selectedIndicator.settings['source'] || 'close'"
                      (change)="updateIndicatorSetting('source', $any($event.target).value)">
                      <option value="close">Close</option>
                      <option value="open">Open</option>
                      <option value="high">High</option>
                      <option value="low">Low</option>
                    </select>
                  </div>
                  <div class="tv-row">
                    <span class="tv-label">Line width</span>
                    <select class="tv-select"
                      [ngModel]="selectedIndicator.settings['lineWidth'] ?? 1"
                      (ngModelChange)="updateIndicatorSetting('lineWidth', $event)">
                      <option [ngValue]="1">1 — thin</option>
                      <option [ngValue]="2">2</option>
                      <option [ngValue]="3">3</option>
                      <option [ngValue]="4">4 — bold</option>
                    </select>
                  </div>
                  <div class="tv-divider"></div>
                  <div class="tv-row">
                    <span class="tv-label">Color</span>
                    <input type="color" class="tv-color-swatch" [value]="selectedIndicator.color"
                      (input)="setIndicatorColor($any($event.target).value)">
                  </div>
                </ng-container>

                <!-- ── ATR ────────────────────────────────────────── -->
                <ng-container *ngIf="selectedIndicator.type === 'atr'">
                  <div class="tv-row">
                    <span class="tv-label">Period</span>
                    <input type="number" class="tv-input" min="1" max="50"
                      [value]="selectedIndicator.settings['period']"
                      (change)="updateIndicatorSetting('period', $any($event.target).value)">
                  </div>
                  <div class="tv-row">
                    <span class="tv-label">Line width</span>
                    <select class="tv-select"
                      [ngModel]="selectedIndicator.settings['lineWidth'] ?? 1"
                      (ngModelChange)="updateIndicatorSetting('lineWidth', $event)">
                      <option [ngValue]="1">1 — thin</option>
                      <option [ngValue]="2">2</option>
                      <option [ngValue]="3">3</option>
                      <option [ngValue]="4">4 — bold</option>
                    </select>
                  </div>
                  <div class="tv-divider"></div>
                  <div class="tv-row">
                    <span class="tv-label">Color</span>
                    <input type="color" class="tv-color-swatch" [value]="selectedIndicator.color"
                      (input)="setIndicatorColor($any($event.target).value)">
                  </div>
                </ng-container>

                <!-- ── Stochastic ─────────────────────────────────── -->
                <ng-container *ngIf="selectedIndicator.type === 'stochastic'">
                  <div class="tv-row">
                    <span class="tv-label">%K Period</span>
                    <input type="number" class="tv-input" min="1" max="100"
                      [value]="selectedIndicator.settings['kPeriod'] || 14"
                      (change)="updateIndicatorSetting('kPeriod', $any($event.target).value)">
                  </div>
                  <div class="tv-row">
                    <span class="tv-label">%D Period</span>
                    <input type="number" class="tv-input" min="1" max="50"
                      [value]="selectedIndicator.settings['dPeriod'] || 3"
                      (change)="updateIndicatorSetting('dPeriod', $any($event.target).value)">
                  </div>
                  <div class="tv-row">
                    <span class="tv-label">Smooth</span>
                    <input type="number" class="tv-input" min="1" max="20"
                      [value]="selectedIndicator.settings['smooth'] || 3"
                      (change)="updateIndicatorSetting('smooth', $any($event.target).value)">
                  </div>
                  <div class="tv-row">
                    <span class="tv-label">Line width</span>
                    <select class="tv-select"
                      [ngModel]="selectedIndicator.settings['lineWidth'] ?? 1"
                      (ngModelChange)="updateIndicatorSetting('lineWidth', $event)">
                      <option [ngValue]="1">1 — thin (%K)</option>
                      <option [ngValue]="2">2</option>
                      <option [ngValue]="3">3</option>
                      <option [ngValue]="4">4 — bold</option>
                    </select>
                  </div>
                  <div class="tv-divider"></div>
                  <div class="tv-row">
                    <span class="tv-label">Color</span>
                    <input type="color" class="tv-color-swatch" [value]="selectedIndicator.color"
                      (input)="setIndicatorColor($any($event.target).value)">
                  </div>
                </ng-container>
              </div>

              <div class="tv-settings-footer">
                <button class="tv-btn-done" (click)="saveIndicatorSettings()">Done</button>
              </div>
            </div>
          </div>

          <!-- Chart Settings Popup -->
          <div class="chart-settings-overlay" *ngIf="showChartSettingsPopup" (click)="toggleDropdown('chartSettings')">
            <div class="chart-settings-popup" (click)="$event.stopPropagation()">
              <div class="chart-settings-header">
                <h3>Chart Settings</h3>
                <button class="close-btn" (click)="toggleDropdown('chartSettings')">
                  <i data-lucide="x"></i>
                </button>
              </div>

              <div class="chart-settings-content">
                <!-- Appearance Section -->
                <div class="setting-group">
                  <div class="setting-group-header">
                    <i data-lucide="palette" class="group-icon"></i>
                    <span class="group-title">Appearance</span>
                  </div>

                  <div class="setting-item">
                    <div class="setting-info">
                      <label class="setting-label">Theme</label>
                      <span class="setting-description">{{currentTheme === 'dark' ? 'Dark Mode' : 'Light Mode'}}</span>
                    </div>
                    <button type="button" class="setting-toggle" (click)="toggleTheme()">
                      <svg *ngIf="currentTheme === 'dark'" class="toggle-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                        <path d="M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z"></path>
                      </svg>
                      <svg *ngIf="currentTheme === 'light'" class="toggle-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                        <circle cx="12" cy="12" r="4"></circle>
                        <path d="M12 2v2"></path>
                        <path d="M12 20v2"></path>
                        <path d="m4.93 4.93 1.41 1.41"></path>
                        <path d="m17.66 17.66 1.41 1.41"></path>
                        <path d="M2 12h2"></path>
                        <path d="M20 12h2"></path>
                        <path d="m6.34 17.66-1.41 1.41"></path>
                        <path d="m19.07 4.93-1.41 1.41"></path>
                      </svg>
                    </button>
                  </div>

                  <div class="setting-item">
                    <div class="setting-info">
                      <label class="setting-label">Grid Lines</label>
                      <span class="setting-description">{{showGridLines ? 'Hide' : 'Show'}} grid lines on chart</span>
                    </div>
                    <button class="setting-toggle" [class.active]="showGridLines" (click)="toggleGridLines()">
                      <i data-lucide="grid-3x3" class="toggle-icon"></i>
                    </button>
                  </div>
                </div>

                <!-- Data Display Section -->
                <div class="setting-group">
                  <div class="setting-group-header">
                    <i data-lucide="bar-chart-3" class="group-icon"></i>
                    <span class="group-title">Data Display</span>
                  </div>

                  <div class="setting-item">
                    <div class="setting-info">
                      <label class="setting-label">Volume</label>
                      <span class="setting-description">{{showVolume ? 'Hide' : 'Show'}} volume bars below chart</span>
                    </div>
                    <button class="setting-toggle" [class.active]="showVolume" (click)="toggleVolume()">
                      <i data-lucide="bar-chart-3" class="toggle-icon"></i>
                    </button>
                  </div>

                  <div class="setting-item">
                    <div class="setting-info">
                      <label class="setting-label">Event Markers</label>
                      <span class="setting-description">{{showMarkers ? 'Hide' : 'Show'}} earnings/dividend
                        markers</span>
                    </div>
                    <button class="setting-toggle" [class.active]="showMarkers" (click)="toggleMarkers()">
                      <i data-lucide="map-pin" class="toggle-icon"></i>
                    </button>
                  </div>

                  <div class="setting-item">
                    <div class="setting-info">
                      <label class="setting-label">Price Line</label>
                      <span class="setting-description">{{showPriceLine ? 'Hide' : 'Show'}} price line overlay</span>
                    </div>
                    <button class="setting-toggle" [class.active]="showPriceLine" (click)="togglePriceLine()">
                      <i data-lucide="trending-up" class="toggle-icon"></i>
                    </button>
                  </div>
                </div>

                <!-- Crosshair Section -->
                <div class="setting-group">
                  <div class="setting-group-header">
                    <i data-lucide="crosshair" class="group-icon"></i>
                    <span class="group-title">Crosshair</span>
                  </div>

                  <div class="setting-item">
                    <div class="setting-info">
                      <label class="setting-label">Crosshair Mode</label>
                      <span class="setting-description">How the crosshair behaves when hovering</span>
                    </div>
                    <div class="setting-options">
                      <button class="setting-option" [class.active]="getCrosshairMode() === 'normal'"
                        (click)="setCrosshairMode('normal')">
                        <i data-lucide="crosshair" class="option-icon"></i>
                        <span class="option-label">Normal</span>
                      </button>
                      <button class="setting-option" [class.active]="getCrosshairMode() === 'magnet'"
                        (click)="setCrosshairMode('magnet')">
                        <i data-lucide="magnet" class="option-icon"></i>
                        <span class="option-label">Magnet</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Loading Overlay with Chart Skeleton (always in DOM for instant show/hide) -->
          <div class="loading-overlay" [class.hidden]="!isLoading">
            <!-- Skeleton Background (Grid & Scale) -->
            <div class="skeleton-chart-bg">
              <div class="skeleton-grid-lines-v"></div>
              <div class="skeleton-grid-lines-h"></div>

              <!-- Fake Candles for Skeleton Effect -->
              <div class="skeleton-candles">
                <div class="skeleton-candle c1"></div>
                <div class="skeleton-candle c2"></div>
                <div class="skeleton-candle c3"></div>
                <div class="skeleton-candle c4"></div>
                <div class="skeleton-candle c5"></div>
              </div>
            </div>

            <!-- Central Loading Indicator -->
            <div class="loading-content">
              <div class="loading-spinner-container">
                <div class="market-loader">
                  <div class="market-bar bar1"></div>
                  <div class="market-bar bar2"></div>
                  <div class="market-bar bar3"></div>
                  <div class="market-bar bar4"></div>
                </div>
              </div>
              <div class="loading-text">Loading Chart Data...</div>
              <div class="loading-subtext">Fetching latest market data</div>
            </div>
          </div>

          <!-- ATR Tooltip -->
          <div *ngIf="atrTooltipData && atrTooltipData.visible" class="atr-tooltip"
            [style.left.px]="atrTooltipData.x" [style.top.px]="atrTooltipData.y">
            <div class="atr-tooltip-header">
              <i data-lucide="bar-chart-3" class="atr-icon"></i>
              <span class="atr-title">{{ atrTooltipData.period }}-Day ATR</span>
            </div>
            <div class="atr-tooltip-value">
              {{ atrTooltipData.atrValue.toFixed(2) }}%
            </div>
            <div class="atr-tooltip-description">
              <small>Average True Range (IBD Formula)</small>
              <br><small>{{ formatATRTooltipDate(atrTooltipData.time) }}</small>
            </div>
          </div>

          <!-- OHLC Tooltip -->
          <div *ngIf="!showChartSettingsPopup && getDisplayTooltipData() as displayTooltipData" class="chart-tooltip-fixed">
            <!-- <div class="tooltip-meta-line">
              <span class="tooltip-symbol">{{ tickerDetails?.companyName || currentSymbol }}</span>
              <span class="tooltip-separator">·</span>
              <span class="tooltip-interval">{{ currentIntervalDisplay }}</span>
            </div> -->

            <div class="tooltip-ohlc-grid">
              <div class="tooltip-data-row">
                <span class="tooltip-label">O</span>
                <span class="tooltip-value">${{ displayTooltipData.data.open.toFixed(2) }}</span>
              </div>

              <div class="tooltip-data-row">
                <span class="tooltip-label">H</span>
                <span class="tooltip-value tooltip-high">${{ displayTooltipData.data.high.toFixed(2) }}</span>
              </div>

              <div class="tooltip-data-row">
                <span class="tooltip-label">L</span>
                <span class="tooltip-value tooltip-low">${{ displayTooltipData.data.low.toFixed(2) }}</span>
              </div>

              <div class="tooltip-data-row">
                <span class="tooltip-label">C</span>
                <span class="tooltip-value"
                  [class.tooltip-positive]="displayTooltipData.data.close >= displayTooltipData.data.open"
                  [class.tooltip-negative]="displayTooltipData.data.close < displayTooltipData.data.open">
                  ${{ displayTooltipData.data.close.toFixed(2) }}
                </span>
              </div>
              <div class="tooltip-data-row">
                <span class="tooltip-label">Δ</span>
                <span class="tooltip-value"
                  [class.tooltip-positive]="getPriceChange(displayTooltipData.data).isPositive"
                  [class.tooltip-negative]="!getPriceChange(displayTooltipData.data).isPositive">
                  {{ getPriceChange(displayTooltipData.data).isPositive ? '+' : '' }}{{
                  getPriceChange(displayTooltipData.data).amount.toFixed(2) }}
                  ({{ getPriceChange(displayTooltipData.data).percentage.toFixed(2) }}%)
                </span>
              </div>

              <div class="tooltip-data-row">
                <span class="tooltip-label">Vol</span>
                <span class="tooltip-value"
                  [class.tooltip-positive]="displayTooltipData.data.close >= displayTooltipData.data.open"
                  [class.tooltip-negative]="displayTooltipData.data.close < displayTooltipData.data.open">
                  {{ displayTooltipData.volumeData?.value != null ? formatVolume(displayTooltipData.volumeData!.value) : '--' }}
                </span>
              </div>
            </div>
          </div>

          <!-- Marker Tooltip -->
          <div *ngIf="markerTooltipData && markerTooltipData.visible" class="marker-tooltip"
            [style.left.px]="markerTooltipData.x + 10" [style.top.px]="markerTooltipData.y - 10">

            <!-- Marker Header -->
            <div class="marker-tooltip-header">
              <span class="marker-icon">{{ markerTooltipData.marker.text }}</span>
              <span class="marker-title">{{ markerTooltipData.marker.title }}</span>
            </div>

            <!-- Marker Description -->
            <div class="marker-tooltip-description">
              {{ markerTooltipData.marker.description }}
            </div>

            <!-- Marker Details -->
            <div *ngIf="markerTooltipData.marker.details" class="marker-tooltip-details">

              <!-- Earnings Details -->
              <div *ngIf="markerTooltipData.marker.category === 'earnings' && markerTooltipData.marker.details">
                <div *ngIf="markerTooltipData.marker.details.estimatedEarnings" class="detail-row">
                  <span class="detail-label">Est. Earnings:</span>
                  <span class="detail-value">{{ markerTooltipData.marker.details.estimatedEarnings }}</span>
                </div>
                <div *ngIf="markerTooltipData.marker.details.earningsHigh" class="detail-row">
                  <span class="detail-label">High Est.:</span>
                  <span class="detail-value">{{ markerTooltipData.marker.details.earningsHigh }}</span>
                </div>
                <div *ngIf="markerTooltipData.marker.details.earningsLow" class="detail-row">
                  <span class="detail-label">Low Est.:</span>
                  <span class="detail-value">{{ markerTooltipData.marker.details.earningsLow }}</span>
                </div>
                <div *ngIf="markerTooltipData.marker.details.revenueEstimate" class="detail-row">
                  <span class="detail-label">Revenue Est.:</span>
                  <span class="detail-value">{{ markerTooltipData.marker.details.revenueEstimate }}</span>
                </div>
                <div *ngIf="markerTooltipData.marker.details.isEstimate" class="detail-row estimate-note">
                  <small><i data-lucide="alert-triangle"></i> Estimated date</small>
                </div>
              </div>

              <!-- Dividend Details -->
              <div *ngIf="markerTooltipData.marker.category === 'dividend' && markerTooltipData.marker.details">
                <div *ngIf="markerTooltipData.marker.details.additionalInfo" class="detail-row">
                  <span class="detail-info">{{ markerTooltipData.marker.details.additionalInfo }}</span>
                </div>
              </div>

              <!-- Generic Details -->
              <div *ngIf="markerTooltipData.marker.details.amount" class="detail-row">
                <span class="detail-label">Amount:</span>
                <span class="detail-value">{{ markerTooltipData.marker.details.amount }}</span>
              </div>

              <div *ngIf="markerTooltipData.marker.details.ratio" class="detail-row">
                <span class="detail-label">Ratio:</span>
                <span class="detail-value">{{ markerTooltipData.marker.details.ratio }}</span>
              </div>
            </div>

            <!-- Close Button -->
            <div class="marker-tooltip-close" (click)="hideMarkerTooltip()">×</div>
          </div>



          <!-- Compact Line Toolbar -->
          <div *ngIf="showLineToolbar && selectedLine" class="compact-line-toolbar" [style.left.px]="toolbarX + 10"
            [style.top.px]="toolbarY - 10">

            <!-- Price Icon with Dropdown -->
            <div class="toolbar-icon-container">
              <div class="toolbar-icon" [class.active]="activeToolbarOption === 'price'"
                (click)="toggleToolbarOption('price')" title="Edit Price">
                <i data-lucide="dollar-sign"></i>
              </div>
              <!-- Price Editor Dropdown -->
              <div *ngIf="activeToolbarOption === 'price'" class="toolbar-dropdown price-dropdown">
                <div class="dropdown-header">Edit Price</div>
                <div class="price-input-container">
                  <input type="number" #priceInput class="price-input" [value]="selectedLine.price"
                    (keyup.enter)="updateLinePriceFromButton(priceInput)" step="0.01" placeholder="Price">
                  <button class="price-save-btn" (click)="updateLinePriceFromButton(priceInput)" title="Save Price">
                    <i data-lucide="check-circle"></i>
                  </button>
                </div>
              </div>
            </div>

            <!-- Color Icon with Dropdown -->
            <div class="toolbar-icon-container">
              <div class="toolbar-icon" [class.active]="activeToolbarOption === 'color'"
                (click)="toggleToolbarOption('color')" title="Change Color">
                <i data-lucide="palette"></i>
              </div>
              <!-- Color Picker Dropdown -->
              <div *ngIf="activeToolbarOption === 'color'" class="toolbar-dropdown color-dropdown">
                <div class="dropdown-header">Choose Color</div>
                <div class="color-grid">
                  <div *ngFor="let color of availableColors" class="color-option-compact"
                    [class.selected]="selectedLine.color === color" [style.background-color]="color"
                    (click)="updateLineColor(color)" [title]="color">
                  </div>
                </div>
              </div>
            </div>

            <!-- Name Icon with Dropdown -->
            <div class="toolbar-icon-container">
              <div class="toolbar-icon" [class.active]="activeToolbarOption === 'name'"
                (click)="toggleToolbarOption('name')" title="Edit Name">
                <i data-lucide="edit-3"></i>
              </div>
              <!-- Name Editor Dropdown -->
              <div *ngIf="activeToolbarOption === 'name'" class="toolbar-dropdown name-dropdown">
                <div class="dropdown-header">Edit Name</div>
                <input type="text" class="name-input" [value]="selectedLine.name"
                  (blur)="updateLineNameFromContext($event)" (keyup.enter)="updateLineNameFromContext($event)"
                  placeholder="Line name">
              </div>
            </div>

            <!-- Delete Icon -->
            <div class="toolbar-icon delete-icon" (click)="deleteLineFromContext()" title="Delete Line">
              <i data-lucide="trash-2"></i>
            </div>
          </div>

          <!-- Compact Text Toolbar -->
          <div *ngIf="showTextToolbar && selectedText" class="compact-text-toolbar" [style.left.px]="textToolbarX + 10"
            [style.top.px]="textToolbarY - 10">

            <!-- Text Icon with Dropdown -->
            <div class="toolbar-icon-container">
              <div class="toolbar-icon" [class.active]="activeTextToolbarOption === 'text'"
                (click)="toggleTextToolbarOption('text')" title="Edit Text">
                <i data-lucide="edit-3"></i>
              </div>
              <!-- Text Editor Dropdown -->
              <div *ngIf="activeTextToolbarOption === 'text'" class="toolbar-dropdown text-edit-dropdown">
                <div class="dropdown-header">Edit Text</div>
                <div class="text-input-container">
                  <textarea #textInput name="chartTextAnnotationText" class="text-input" rows="3"
                    [ngModel]="selectedText.text" (ngModelChange)="selectedText.text = $event"
                    (paste)="onPasteImageInTextField($event, textInput)"
                    (keydown.control.enter)="updateTextContent(textInput); $event.preventDefault()"
                    (keydown.meta.enter)="updateTextContent(textInput); $event.preventDefault()"
                    placeholder="Enter text or paste an image (Ctrl+V / ⌘V)"></textarea>
                  <button class="text-save-btn" (click)="updateTextContent(textInput)" title="Save Text">
                    <i data-lucide="check-circle"></i>
                  </button>
                </div>
              </div>
            </div>

            <!-- Color Icon with Dropdown -->
            <div class="toolbar-icon-container">
              <div class="toolbar-icon" [class.active]="activeTextToolbarOption === 'color'"
                (click)="toggleTextToolbarOption('color')" title="Change Color">
                <i data-lucide="palette"></i>
              </div>
              <!-- Color Picker Dropdown -->
              <div *ngIf="activeTextToolbarOption === 'color'" class="toolbar-dropdown color-dropdown">
                <div class="dropdown-header">Text Color</div>
                <div class="color-grid">
                  <div *ngFor="let color of availableTextColors" class="color-option-compact"
                    [class.selected]="selectedText.fontColor === color" [style.background-color]="color"
                    (click)="updateTextColor(color)" [title]="color">
                  </div>
                </div>
              </div>
            </div>

            <!-- Size Icon with Dropdown -->
            <div class="toolbar-icon-container">
              <div class="toolbar-icon" [class.active]="activeTextToolbarOption === 'size'"
                (click)="toggleTextToolbarOption('size')" title="Font Size">
                <i data-lucide="ruler"></i>
              </div>
              <!-- Font Size Dropdown -->
              <div *ngIf="activeTextToolbarOption === 'size'" class="toolbar-dropdown size-dropdown">
                <div class="dropdown-header">Font Size</div>
                <div class="size-grid">
                  <div *ngFor="let size of availableFontSizes" class="size-option"
                    [class.selected]="selectedText.fontSize === size" (click)="updateTextSize(size)">
                    {{size}}px
                  </div>
                </div>
              </div>
            </div>

            <!-- Style Icon with Dropdown -->
            <div class="toolbar-icon-container">
              <div class="toolbar-icon" [class.active]="activeTextToolbarOption === 'style'"
                (click)="toggleTextToolbarOption('style')" title="Text Style">
                <i data-lucide="type"></i>
              </div>
              <!-- Style Dropdown -->
              <div *ngIf="activeTextToolbarOption === 'style'" class="toolbar-dropdown style-dropdown">
                <div class="dropdown-header">Text Style</div>
                <div class="style-options">
                  <div class="style-option" [class.selected]="selectedText.style === 'normal'"
                    (click)="updateTextStyle('normal')">
                    Normal
                  </div>
                  <div class="style-option" [class.selected]="selectedText.style === 'bold'"
                    (click)="updateTextStyle('bold')">
                    <strong>Bold</strong>
                  </div>
                  <div class="style-option" [class.selected]="selectedText.style === 'italic'"
                    (click)="updateTextStyle('italic')">
                    <em>Italic</em>
                  </div>
                </div>
              </div>
            </div>

            <!-- Background Icon with Dropdown -->
            <div class="toolbar-icon-container">
              <div class="toolbar-icon" [class.active]="activeTextToolbarOption === 'background'"
                (click)="toggleTextToolbarOption('background')" title="Background Color">
                <i data-lucide="palette"></i>
              </div>
              <!-- Background Color Dropdown -->
              <div *ngIf="activeTextToolbarOption === 'background'" class="toolbar-dropdown color-dropdown">
                <div class="dropdown-header">Background Color</div>
                <div class="color-grid">
                  <div class="color-option-compact"
                    [class.selected]="!selectedText.backgroundColor || selectedText.backgroundColor === 'transparent'"
                    [style.background]="'transparent'" style="border: 2px dashed #666;"
                    (click)="updateTextBackgroundColor('transparent')" title="No Background">
                  </div>
                  <div *ngFor="let color of availableTextColors" class="color-option-compact"
                    [class.selected]="selectedText.backgroundColor === color" [style.background-color]="color"
                    (click)="updateTextBackgroundColor(color)" [title]="color">
                  </div>
                </div>
              </div>
            </div>

            <!-- Border Icon with Dropdown -->
            <div class="toolbar-icon-container">
              <div class="toolbar-icon" [class.active]="activeTextToolbarOption === 'border'"
                (click)="toggleTextToolbarOption('border')" title="Border Options">
                <i data-lucide="square"></i>
              </div>
              <!-- Border Options Dropdown -->
              <div *ngIf="activeTextToolbarOption === 'border'" class="toolbar-dropdown border-dropdown">
                <div class="dropdown-header">Border Options</div>
                <div class="border-options">
                  <div class="border-section">
                    <label class="border-label">Border Color</label>
                    <div class="color-grid mini">
                      <div class="color-option-compact"
                        [class.selected]="!selectedText.borderColor || selectedText.borderColor === 'transparent'"
                        [style.background]="'transparent'" style="border: 2px dashed #666;"
                        (click)="updateTextBorderColor('transparent')" title="No Border">
                      </div>
                      <div *ngFor="let color of availableTextColors" class="color-option-compact"
                        [class.selected]="selectedText.borderColor === color" [style.background-color]="color"
                        (click)="updateTextBorderColor(color)" [title]="color">
                      </div>
                    </div>
                  </div>
                  <div class="border-section">
                    <label class="border-label">Border Width</label>
                    <div class="border-width-options">
                      <div class="border-width-option" [class.selected]="selectedText.borderWidth === 0"
                        (click)="updateTextBorderWidth(0)">None</div>
                      <div class="border-width-option" [class.selected]="selectedText.borderWidth === 1"
                        (click)="updateTextBorderWidth(1)">1px</div>
                      <div class="border-width-option" [class.selected]="selectedText.borderWidth === 2"
                        (click)="updateTextBorderWidth(2)">2px</div>
                      <div class="border-width-option" [class.selected]="selectedText.borderWidth === 3"
                        (click)="updateTextBorderWidth(3)">3px</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Delete Icon -->
            <div class="toolbar-icon delete-icon" (click)="deleteTextFromContext()" title="Delete Text">
              <i data-lucide="trash-2"></i>
            </div>
          </div>
        </div> <!-- End chart-container-wrapper -->

        <!-- Bottom Toolbar -->
        <div class="bottom-toolbar" *ngIf="showBottomToolbar">
          <!-- Time Intervals (TradingView style) -->

          <div class="timeframe-group">
            <span class="toolbar-label">Time Range:</span>
            <button *ngFor="let interval of timeRanges" (click)="changeInterval(interval.value)"
              [class.active]="isActiveTimeRange(interval.value)" [class.default]="interval.isDefault"
              class="timeframe-btn-compact"
              [title]="interval.isDefault ? interval.label + ' (Default)' : interval.label">
              {{interval.label}}
              <span *ngIf="interval.isDefault" class="default-badge" title="Default">★</span>
            </button>
          </div>

          <!-- Divider -->
          <div class="toolbar-divider"></div>
          <div class="interval-selector-container">
            <!-- Interval Selector Dropdown -->
            <div class="interval-selector" [class.active]="showIntervalDropdown">
              <div class="toolbar-label">Interval:</div>
              <button class="interval-btn" (click)="toggleIntervalDropdown()"
                [title]="'Current: ' + currentIntervalDescription">
                <span class="interval-display">{{currentIntervalDisplay}}</span>
                <span class="dropdown-arrow">▼</span>
              </button>
              <div class="interval-dropdown" *ngIf="showIntervalDropdown">
                <div class="interval-dropdown-header">Candle Interval</div>
                <button type="button" class="interval-option" [class.active]="selectedInterval === null"
                  [class.disabled]="currentInterval?.toLowerCase() === 'all'"
                  (click)="selectInterval(null); $event.stopPropagation()">
                  <span class="interval-label">Auto</span>
                  <span class="interval-desc">Based on time range</span>
                </button>
                <button type="button" *ngFor="let interval of availableIntervals; trackBy: trackByChartIntervalValue"
                  class="interval-option"
                  [class.active]="selectedInterval === interval.value" [class.default]="interval.isDefault"
                  [class.disabled]="!isIntervalValidForCurrentRange(interval.value)"
                  (click)="selectInterval(interval.value); $event.stopPropagation()"
                  [title]="interval.isDefault ? interval.description + ' (Default)' : interval.description">
                  <span class="interval-label">
                    {{interval.label}}
                    <span *ngIf="interval.isDefault" class="default-badge" title="Default">★</span>
                  </span>
                  <span class="interval-desc">{{interval.description}}</span>
                </button>
              </div>
            </div>

            <!-- Chart Settings -->
            <div class="chart-settings-dropdown" [class.active]="showChartSettingsPopup">
              <button class="settings-toolbar-btn" (click)="toggleDropdown('chartSettings')" title="Chart Settings">
                <i data-lucide="settings" class="settings-toolbar-icon"></i>
              </button>
            </div>
          </div>
        </div>

        <!-- Drawing tool status — compact row directly below footer -->
        <div class="tool-status-bar" *ngIf="showToolbar && hasActiveTools()">
          <div class="active-tools">
            <div class="tool-status-item" *ngIf="isDrawingMode">
              <i data-lucide="minus" class="status-icon"></i>
              <span class="status-text">Line Tool active</span>
              <button type="button" class="status-action" (click)="toggleDrawingMode()" title="Exit Line Tool">✕</button>
            </div>
            <div class="tool-status-item" *ngIf="isPenMode">
              <i data-lucide="pencil" class="status-icon"></i>
              <span class="status-text">Pen Tool active ({{penColor}}, {{penSize}}px)</span>
              <button type="button" class="status-action" (click)="togglePenMode()" title="Exit Pen Tool">✕</button>
            </div>
            <div class="tool-status-item" *ngIf="isTextMode">
              <i data-lucide="type" class="status-icon"></i>
              <span class="status-text">Text Tool active</span>
              <button type="button" class="status-action" (click)="toggleTextMode()" title="Exit Text Tool">✕</button>
            </div>
            <div class="tool-status-item" *ngIf="isArrowMode">
              <i data-lucide="arrow-up-right" class="status-icon"></i>
              <span class="status-text">Arrow Tool active</span>
              <button type="button" class="status-action" (click)="toggleArrowMode()" title="Exit Arrow Tool">✕</button>
            </div>
            <div class="tool-status-item" *ngIf="showLineToolbar && selectedLine">
              <i data-lucide="target" class="status-icon"></i>
              <span class="status-text">Editing: {{selectedLine.name}}</span>
              <button type="button" class="status-action" (click)="deselectLine()" title="Deselect Line">✕</button>
            </div>
            <div class="tool-status-item" *ngIf="showPenToolbar && selectedPenDrawing">
              <i data-lucide="palette" class="status-icon"></i>
              <span class="status-text">Editing: {{selectedPenDrawing.name}}</span>
              <button type="button" class="status-action status-action--confirm" (click)="deselectPenDrawing()" title="Done Editing">✓</button>
            </div>
            <div class="tool-status-item" *ngIf="showTextToolbar && selectedText">
              <i data-lucide="edit-3" class="status-icon"></i>
              <span class="status-text">Editing: "{{selectedText.text | slice:0:20}}{{selectedText.text.length > 20 ? '...' : ''}}"</span>
              <button type="button" class="status-action status-action--confirm" (click)="deselectText()" title="Done Editing">✓</button>
            </div>
            <div class="tool-status-item" *ngIf="showArrowToolbar && selectedArrowDrawing">
              <i data-lucide="move-up-right" class="status-icon"></i>
              <span class="status-text">Editing: {{selectedArrowDrawing.name || 'Arrow'}}</span>
              <button type="button" class="status-action status-action--confirm" (click)="deselectArrowDrawing()" title="Done Editing">✓</button>
            </div>
          </div>
          <div class="status-help">
            <span class="help-text">Press <kbd>ESC</kbd> to exit current mode</span>
          </div>
        </div>
      </div> <!-- End main-content -->

    </div> <!-- End chart-wrapper -->

    <!-- Sidebar Area -->
    <div class="sidebar-area" *ngIf="showSidebar" [class.pane-open]="isRecentTickersPaneOpen">
      <!-- Sidebar Toggle Button -->
      <div class="sidebar-toggle" [class.pane-open]="isRecentTickersPaneOpen" (click)="toggleRecentTickersPane()"
        [title]="isEmbeddedView ? 'Watchlists (open/close)' : 'Tickers & Watchlists (open/close)'">
        <span class="toggle-chevron-wrap" [class.toggle-chevron-wrap--open]="isRecentTickersPaneOpen">
          <svg class="toggle-chevron-svg" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true" focusable="false">
            <path d="M15 18l-6-6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </span>
      </div>

      <!-- Sidebar Pane -->
      <div class="sidebar-pane" [class.open]="isRecentTickersPaneOpen">

        <!-- Tab Navigation -->
        <div class="sidebar-tabs">
          <button class="sidebar-tab" *ngIf="!isEmbeddedView" [class.active]="activeSidebarTab === 'recent'"
            (click)="switchSidebarTab('recent')">
            <i data-lucide="clock" class="tab-icon"></i>
            <span class="tab-text">Recent</span>
          </button>
          <button class="sidebar-tab" [class.active]="activeSidebarTab === 'watchlists'"
            (click)="switchSidebarTab('watchlists')">
            <i data-lucide="star" class="tab-icon"></i>
            <span class="tab-text">Watchlists</span>
          </button>
        </div>

        <!-- Recent Tickers Tab Content -->
        <div class="tab-content" *ngIf="activeSidebarTab === 'recent' && !isEmbeddedView">
          <div class="tab-header">
            <div class="header-title">
              <i data-lucide="trending-up" class="header-icon"></i>
              <span class="header-text">Recent Tickers</span>
            </div>
            <!-- <button class="clear-recent-btn" (click)="clearRecentTickers()" *ngIf="recentTickers.length > 0"
              title="Clear All">
              <i data-lucide="trash-2"></i>
            </button> -->
          </div>

          <div class="tickers-list recent-market-list">
            <div *ngIf="recentTickers.length === 0" class="empty-state">
              <div class="empty-icon"><i data-lucide="bar-chart-3"></i></div>
              <div class="empty-text">No recent tickers</div>
              <div class="empty-subtext">Charts you view will appear here</div>
            </div>

            <div *ngIf="recentTickers.length > 0" class="ticker-table-header">
              <span class="th-symbol">Symbol</span>
              <span class="th-price">Last</span>
              <span class="th-change">Chg</span>
              <span class="th-percent">Chg%</span>
            </div>

            <div *ngFor="let ticker of recentTickers; trackBy: trackByTicker"
              class="ticker-item ticker-data-item market-table-row recent-market-row"
              [class.current]="ticker.symbol === currentSymbol" (click)="selectRecentTicker(ticker)">
              <div class="ticker-symbol-cell">
                <span class="symbol-text">{{ ticker.symbol }}</span>
                <span class="symbol-dot">●</span>
              </div>

              <div class="ticker-data">
                <div class="data-column price-column">
                  <div class="data-label">Price</div>
                  <div class="data-value">${{ formatPrice(ticker.lastPrice) }}</div>
                </div>

                <div class="data-column change-column">
                  <div class="data-label">Change</div>
                  <div class="data-value" [class]="getChangeClass(ticker.change)">
                    {{ formatChange(ticker.change) }}
                  </div>
                </div>

                <div class="data-column percent-column">
                  <div class="data-label">%</div>
                  <div class="data-value" [class]="getChangeClass(ticker.changePercent)">
                    {{ formatChangePercent(ticker.changePercent) }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Watchlists Tab Content -->
        <div class="tab-content" *ngIf="activeSidebarTab === 'watchlists'">
          <div class="tab-header">
            <div class="header-title">
              <i data-lucide="star" class="header-icon"></i>
              <span class="header-text">Watchlists</span>
            </div>
            <!-- <button class="add-to-watchlist-btn" (click)="addCurrentSymbolToWatchlist()"
              [disabled]="isCurrentSymbolInWatchlist()" title="Add current symbol to watchlist">
              <i *ngIf="isCurrentSymbolInWatchlist()" data-lucide="check" class="watchlist-icon check-icon"></i>
              <i *ngIf="!isCurrentSymbolInWatchlist()" data-lucide="plus" class="watchlist-icon plus-icon"></i>
            </button> -->
          </div>

          <!-- Watchlist Selector -->
          <div class="watchlist-selector">
            <div class="watchlist-controls">
              <select class="watchlist-dropdown" #watchlistSelect [(ngModel)]="selectedWatchlistId"
                (ngModelChange)="selectWatchlist($event)">
                <option *ngFor="let watchlist of watchlists" [ngValue]="watchlist.id">
                  {{ watchlist.name }} ({{ watchlist.items.length }})
                </option>
              </select>

              <div class="watchlist-actions">
                <button class="watchlist-action-btn" type="button" (click)="openAddWatchlistSymbolModal()"
                  title="Add symbol to watchlist">
                  <i data-lucide="plus" class="watchlist-add-icon"></i>
                </button>

                <button class="watchlist-action-btn" type="button" (click)="toggleWatchlistMenu()"
                  [class.active]="showWatchlistMenu" title="Watchlist Options">
                  ⋯
                </button>
              </div>
            </div>

            <!-- Watchlist Management Menu -->
            <div class="watchlist-menu" *ngIf="showWatchlistMenu">
              <div class="menu-item" (click)="openEditWatchlistModal()">
                <i data-lucide="edit-3" class="menu-icon"></i>
                <span class="menu-text">Edit</span>
              </div>
              <div class="menu-item danger" (click)="deleteCurrentWatchlist()"
                *ngIf="!getSelectedWatchlist()?.isDefault">
                <i data-lucide="trash-2" class="menu-icon"></i>
                <span class="menu-text">Delete</span>
              </div>
              <div class="menu-item" (click)="clearCurrentWatchlist()">
                <i data-lucide="eraser" class="menu-icon"></i>
                <span class="menu-text">Clear All Items</span>
              </div>
            </div>
          </div>

          <!-- Watchlist Items -->
          <div class="tickers-list watchlist-market-list" *ngIf="getSelectedWatchlist() as selectedWatchlist">
            <div *ngIf="isLoadingWatchlistSymbols" class="empty-state">
              <div class="empty-icon"><i data-lucide="loader-2" class="loading-spinner"></i></div>
              <div class="empty-text">Loading symbols...</div>
            </div>
            <div *ngIf="!isLoadingWatchlistSymbols && selectedWatchlist.items.length === 0" class="empty-state">
              <div class="empty-icon"><i data-lucide="star"></i></div>
              <div class="empty-text">No tickers in watchlist</div>
              <div class="empty-subtext">Add symbols to track them here</div>
            </div>

            <ng-container *ngIf="!isLoadingWatchlistSymbols">
              <div *ngIf="selectedWatchlist.items.length > 0" class="ticker-table-header">
                <span class="th-symbol">Symbol</span>
                <span class="th-price">Last</span>
                <span class="th-change">Chg</span>
                <span class="th-percent">Chg%</span>
              </div>
              <div *ngFor="let item of selectedWatchlist.items"
                class="ticker-item ticker-data-item watchlist-item market-table-row"
                [class.current]="item.symbol === currentSymbol" (click)="selectWatchlistTicker(item)">
                <div class="ticker-symbol-cell">
                  <span class="symbol-text">{{ item.symbol }}</span>
                  <span class="symbol-dot">●</span>
                </div>

                <div class="ticker-data">
                  <div class="data-column price-column">
                    <div class="data-label">Price</div>
                    <div class="data-value">${{ formatPrice(item.lastPrice) }}</div>
                  </div>

                  <div class="data-column change-column">
                    <div class="data-label">Change</div>
                    <div class="data-value" [class]="getChangeClass(item.change)">
                      {{ formatChange(item.change) }}
                    </div>
                  </div>

                  <div class="data-column percent-column">
                    <div class="data-label">%</div>
                    <div class="data-value" [class]="getChangeClass(item.changePercent)">
                      {{ formatChangePercent(item.changePercent) }}
                    </div>
                  </div>
                </div>

                <button type="button" class="watchlist-row-remove-btn"
                  (click)="removeFromWatchlist(item); $event.stopPropagation()"
                  [attr.aria-label]="'Remove ' + item.symbol + ' from watchlist'"
                  [attr.title]="'Remove ' + item.symbol">
                  <i data-lucide="trash-2" class="remove-icon"></i>
                </button>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div> <!-- End sidebar-area -->

    <!-- Arrow Drawing Editing Toolbar -->
    <div class="compact-arrow-toolbar" *ngIf="showArrowToolbar && selectedArrowDrawing" [style.left.px]="arrowToolbarX"
      [style.top.px]="arrowToolbarY">

      <div class="toolbar-icon" [class.active]="activeArrowToolbarOption === 'color'"
        (click)="toggleArrowToolbarOption('color')" title="Change Arrow Color">
        <i data-lucide="palette"></i>
      </div>

      <div class="toolbar-icon" [class.active]="activeArrowToolbarOption === 'size'"
        (click)="toggleArrowToolbarOption('size')" title="Change Arrow Width">
        <i data-lucide="ruler" class="toolbar-icon"></i>
      </div>

      <div class="toolbar-icon" (click)="deleteSelectedArrowFromContext()" title="Delete Arrow">
        <i data-lucide="trash-2"></i>
      </div>

      <div class="toolbar-dropdown color-dropdown" *ngIf="activeArrowToolbarOption === 'color'">
        <div class="color-grid">
          <div *ngFor="let color of availableColors" class="color-option" [style.background-color]="color"
            [class.selected]="selectedArrowDrawing.color === color" (click)="updateSelectedArrowColor(color)"
            [title]="color">
          </div>
        </div>
      </div>

      <div class="toolbar-dropdown size-dropdown" *ngIf="activeArrowToolbarOption === 'size'">
        <div class="size-option" [class.selected]="selectedArrowDrawing.lineWidth === 1"
          (click)="updateSelectedArrowLineWidth(1)">
          <div class="size-preview" style="width: 2px; height: 2px;"></div>
          <span>Thin (1px)</span>
        </div>
        <div class="size-option" [class.selected]="selectedArrowDrawing.lineWidth === 2"
          (click)="updateSelectedArrowLineWidth(2)">
          <div class="size-preview" style="width: 4px; height: 4px;"></div>
          <span>Medium (2px)</span>
        </div>
        <div class="size-option" [class.selected]="selectedArrowDrawing.lineWidth === 3"
          (click)="updateSelectedArrowLineWidth(3)">
          <div class="size-preview" style="width: 6px; height: 6px;"></div>
          <span>Thick (3px)</span>
        </div>
        <div class="size-option" [class.selected]="selectedArrowDrawing.lineWidth === 4"
          (click)="updateSelectedArrowLineWidth(4)">
          <div class="size-preview" style="width: 8px; height: 8px;"></div>
          <span>Extra Thick (4px)</span>
        </div>
      </div>
    </div>

    <!-- Pen Drawing Editing Toolbar -->
    <div class="compact-pen-toolbar" *ngIf="showPenToolbar && selectedPenDrawing" [style.left.px]="penToolbarX"
      [style.top.px]="penToolbarY">

      <!-- Color option -->
      <div class="toolbar-icon" [class.active]="activePenToolbarOption === 'color'"
        (click)="togglePenToolbarOption('color')" title="Change Color">
        <i data-lucide="palette"></i>
      </div>

      <!-- Size option -->
      <div class="toolbar-icon" [class.active]="activePenToolbarOption === 'size'"
        (click)="togglePenToolbarOption('size')" title="Change Line Width">
        <i data-lucide="ruler" class="toolbar-icon"></i>
      </div>

      <!-- Delete option -->
      <div class="toolbar-icon" (click)="deletePenDrawingFromContext()" title="Delete Drawing">
        <i data-lucide="trash-2"></i>
      </div>

      <!-- Color Dropdown -->
      <div class="toolbar-dropdown color-dropdown" *ngIf="activePenToolbarOption === 'color'">
        <div class="color-grid">
          <div *ngFor="let color of availableColors" class="color-option" [style.background-color]="color"
            [class.selected]="selectedPenDrawing.color === color" (click)="updatePenDrawingColor(color)"
            [title]="color">
          </div>
        </div>
      </div>

      <!-- Size Dropdown -->
      <div class="toolbar-dropdown size-dropdown" *ngIf="activePenToolbarOption === 'size'">
        <div class="size-option" [class.selected]="selectedPenDrawing.lineWidth === 1"
          (click)="updatePenDrawingLineWidth(1)">
          <div class="size-preview" style="width: 2px; height: 2px;"></div>
          <span>Thin (1px)</span>
        </div>
        <div class="size-option" [class.selected]="selectedPenDrawing.lineWidth === 2"
          (click)="updatePenDrawingLineWidth(2)">
          <div class="size-preview" style="width: 4px; height: 4px;"></div>
          <span>Medium (2px)</span>
        </div>
        <div class="size-option" [class.selected]="selectedPenDrawing.lineWidth === 3"
          (click)="updatePenDrawingLineWidth(3)">
          <div class="size-preview" style="width: 6px; height: 6px;"></div>
          <span>Thick (3px)</span>
        </div>
        <div class="size-option" [class.selected]="selectedPenDrawing.lineWidth === 4"
          (click)="updatePenDrawingLineWidth(4)">
          <div class="size-preview" style="width: 8px; height: 8px;"></div>
          <span>Extra Thick (4px)</span>
        </div>
      </div>
    </div>
  </div> <!-- End main-content -->

  <!-- Add Symbol to Watchlist Modal -->
  <div class="modal-overlay" *ngIf="showAddWatchlistSymbolModal" (click)="closeAddWatchlistSymbolModal()">
    <div class="modal-content add-symbol-modal" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3 class="modal-title">Add Symbol to Watchlist</h3>
        <button class="modal-close" (click)="closeAddWatchlistSymbolModal()">×</button>
      </div>

      <div class="modal-body">
        <div class="form-helper-text" *ngIf="getSelectedWatchlist() as wl">
          Adding to: <strong>{{ wl.name }}</strong>
        </div>

        <div class="form-checkbox add-current-ticker-option" *ngIf="currentSymbol">
          <input type="checkbox" id="addCurrentTickerToWatchlist" [(ngModel)]="addCurrentTickerToWatchlist" />
          <label for="addCurrentTickerToWatchlist">Add current chart symbol <strong>{{ currentSymbol }}</strong></label>
        </div>

        <div class="form-group">
          <label for="addSymbolSearch">Search and select more symbols</label>
          <input id="addSymbolSearch" type="text" class="form-input" [(ngModel)]="watchlistSymbolSearchQuery"
            (ngModelChange)="onWatchlistSearchInput()" placeholder="Type to search (e.g., AAPL, Tesla)" />
        </div>

        <div class="add-symbol-results" *ngIf="watchlistSymbolSearchLoading">
          <span class="add-symbol-loading">Searching...</span>
        </div>
        <div class="add-symbol-results"
          *ngIf="!watchlistSymbolSearchLoading && watchlistSymbolSearchQuery.trim().length >= 2 && watchlistSymbolSearchResults.length === 0">
          <span class="add-symbol-empty">No symbols found. Try a different search.</span>
        </div>
        <ul class="add-symbol-list" *ngIf="!watchlistSymbolSearchLoading && watchlistSymbolSearchResults.length > 0">
          <li *ngFor="let item of watchlistSymbolSearchResults" class="add-symbol-item"
            (click)="toggleWatchlistSymbolSelection(item)">
            <input type="checkbox" [checked]="isWatchlistSymbolSelected(item.symbol)"
              (change)="toggleWatchlistSymbolSelection(item)" (click)="$event.stopPropagation()" />
            <span class="add-symbol-symbol">{{ item.symbol }}</span>
            <span class="add-symbol-name" *ngIf="item.name">{{ item.name }}</span>
            <span class="add-symbol-exchange" *ngIf="item.exchange">{{ item.exchange }}</span>
          </li>
        </ul>

        <div class="add-symbol-selected"
          *ngIf="watchlistSymbolsSelected.length > 0 || (addCurrentTickerToWatchlist && currentSymbol)">
          <div class="add-symbol-selected-label">Will add ({{ getAddWatchlistSymbolCount() }})</div>
          <div class="add-symbol-selected-chips">
            <span *ngIf="addCurrentTickerToWatchlist && currentSymbol" class="add-symbol-chip add-symbol-chip-current">
              {{ currentSymbol }} <span class="add-symbol-chip-label">(current)</span>
            </span>
            <span *ngFor="let item of watchlistSymbolsSelected" class="add-symbol-chip">
              {{ item.symbol }}
              <button type="button" class="add-symbol-chip-remove"
                (click)="removeWatchlistSelectedSymbol(item.symbol)">×</button>
            </span>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button class="btn btn-secondary" type="button" (click)="closeAddWatchlistSymbolModal()">Cancel</button>
        <button class="btn btn-primary" type="button" (click)="confirmAddWatchlistSymbol()"
          [disabled]="getAddWatchlistSymbolCount() === 0 || !getSelectedWatchlist()">
          Add {{ getAddWatchlistSymbolCount() > 0 ? getAddWatchlistSymbolCount() : '' }} Symbol{{
          getAddWatchlistSymbolCount() !== 1 ? 's' : '' }}
        </button>
      </div>
    </div>
  </div>

  <!-- Edit Watchlist Modal -->
  <div class="modal-overlay" *ngIf="showEditWatchlistModal" (click)="closeEditWatchlistModal()">
    <div class="modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3 class="modal-title">Edit Watchlist</h3>
        <button class="modal-close" (click)="closeEditWatchlistModal()">×</button>
      </div>

      <div class="modal-body">
        <div class="form-group">
          <label for="editWatchlistName">Name</label>
          <input id="editWatchlistName" type="text" class="form-input" [(ngModel)]="editWatchlistName"
            placeholder="Watchlist name" maxlength="50" (keyup.enter)="saveEditWatchlist()" />
        </div>
        <div class="form-group">
          <label for="editWatchlistDescription">Description (optional)</label>
          <input id="editWatchlistDescription" type="text" class="form-input" [(ngModel)]="editWatchlistDescription"
            placeholder="Brief description" maxlength="100" />
        </div>
      </div>

      <div class="modal-footer">
        <button class="btn btn-secondary" type="button" (click)="closeEditWatchlistModal()">Cancel</button>
        <button class="btn btn-primary" type="button" (click)="saveEditWatchlist()"
          [disabled]="!editWatchlistName.trim()">
          Save
        </button>
      </div>
    </div>
  </div>

  <!-- Create Watchlist Modal -->
  <div class="modal-overlay" *ngIf="showCreateWatchlist" (click)="showCreateWatchlist = false">
    <div class="modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3 class="modal-title">Create New Watchlist</h3>
        <button class="modal-close" (click)="showCreateWatchlist = false">×</button>
      </div>

      <div class="modal-body">
        <div class="form-group">
          <label for="watchlistName">Watchlist Name</label>
          <input type="text" id="watchlistName" class="form-input" [(ngModel)]="newWatchlistName"
            placeholder="e.g., Tech Stocks, Growth Picks" maxlength="50" (keyup.enter)="createWatchlistAndAdd()">
        </div>

        <div class="form-group">
          <label for="watchlistDescription">Description (Optional)</label>
          <input type="text" id="watchlistDescription" class="form-input" [(ngModel)]="newWatchlistDescription"
            placeholder="Brief description of this watchlist" maxlength="100">
        </div>

        <div class="form-checkbox" *ngIf="currentSymbol && !isCurrentSymbolInWatchlist()">
          <input type="checkbox" id="addCurrentSymbol" [(ngModel)]="addCurrentSymbolToNew">
          <label for="addCurrentSymbol">Add "{{currentSymbol}}" to this watchlist</label>
        </div>
      </div>

      <div class="modal-footer">
        <button class="btn btn-secondary" (click)="cancelCreateWatchlist()">Cancel</button>
        <button class="btn btn-primary" (click)="createWatchlistAndAdd()" [disabled]="!newWatchlistName.trim()">
          Create Watchlist
        </button>
      </div>
    </div>
  </div>
</div>